import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Input,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  Table,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Label,
  FormGroup,
  Badge,
  Toast
} from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaCalendarAlt, FaCartPlus, FaEnvelope, FaEye, FaHistory, FaImage, FaList, FaMapMarkerAlt, FaMinus, FaMoneyBillWave, FaPlus, FaPrint, FaReceipt, FaSearch, FaShoppingCart, FaStore, FaTh, FaTimes, FaTrash, FaUser, FaWhatsapp } from 'react-icons/fa'; // Import trash icon
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from "react-i18next";
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import emptyCart from "../../assets/images/empty-cart.png";
import { productActions } from "../../sagas/productSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce, set } from "lodash";
import { saleActions } from "../../sagas/saleSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import config from "../../helpers/config";
import { FaCheckSquare } from 'react-icons/fa';

const SaleForm = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [modalSearchTerm, setModalSearchTerm] = useState(''); // Separate state for modal search
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [amountPaid, setAmountPaid] = useState(0);
  const cart = useSelector(state => state.sales?.cart || []);
  const [cartPage, setCartPage] = useState(1);
  const totalAmount = useSelector(state => state.sales?.totalAmount || 0);
  const [clearCartModal, setClearCartModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const fullName = useSelector(state => state.auth.fullName);
  const { businessName, email, address, telephone } = useSelector(state => state.auth);
  const [displayMode, setDisplayMode] = useState('card'); // or 'card'
  const [chooseProductModal, setChooseProductModal] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const quantityInputRef = useRef(null);
  const priceInputRef = useRef(null);
  const highlightedItem = useSelector((state) => state.sales.highlightedItem);
  const barcodeFocus = useSelector((state) => state.sales.barcodeFocus);
  const isExisting = useSelector((state) => state.sales.isExisting);
  const [itemQuantities, setItemQuantities] = useState(null);

  // Add inside component
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    products,
    loading,
    totalPages,
    totalElements,
    pageNumber,
    pageSize,
    error,
  } = useSelector((state) => state.products);
  const [selectedProductDetails, setSelectedProductDetails] = useState(null);
  const { currentSale, isLoading } = useSelector((state) => state.sales);
  const searchInputRef = useRef(null);

  console.log(cart)
  const toggleClearCartModal = () => setClearCartModal(!clearCartModal);


  const togglePaymentModal = () => setPaymentModal(!paymentModal);

  const handlePayment = () => {
    // Process payment logic here
    togglePaymentModal();
  };

  const handleBarcodeFocusToggle = (e) => {
    dispatch(saleActions.setBarcodeFocus(e.target.checked));
  };

  const toggleModal = () => setModal(!modal);
  const { t } = useTranslation();

  const formatPrice = (amount, currency = true) => {
    const formattedPrice = new Intl.NumberFormat('fr-MA', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    return currency ? `${formattedPrice} DH` : formattedPrice;
  };

  useEffect(() => {
    let payload = {
      query: searchTerm,
      page: currentPage,
      size: pageSize,
    };
    dispatch(productActions.search(payload));
  }, [currentPage]);

  useEffect(() => {
    dispatch(saleActions.fetchOpenSale());
  }, []);

  const [itemPrices, setItemPrices] = useState(null);


  useEffect(() => {
    // Auto focus on mount
    searchInputRef.current?.focus();

    // Add keyboard shortcut
    const handleKeyDown = (e) => {
      if (e.key === 'F2') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [products]);

  const handleCloseProductDetails = () => {
    setSelectedProductDetails(null);
  };


  useEffect(() => {
    if (barcodeFocus) {
      searchInputRef.current.focus();
    } else {
      if (highlightedItem && itemQuantities) {
        if (quantityInputRef.current) {
          quantityInputRef.current.focus();
        }
        return;
      }

      else if (highlightedItem && itemPrices) {
        if (priceInputRef.current) {
          priceInputRef.current.focus();
        }
        return;
      }
      else{
        if (quantityInputRef.current) {
          quantityInputRef.current.focus();
        }
      }
    }

  }, [highlightedItem, isLoading, isExisting]);


  const handleAddToCart = (product) => {
    if (product.stock <= 0) {
      Swal.fire({
        icon: 'warning',
        title: t('product.outOfStock'),
        text: `${t('product.outOfStockMessage')} (${product.description})`,
        confirmButtonText: t('common.ok'),
      });
      return;
    }

    let payload = {
      productId: product.id,
      quantity: 1,
      saleId: currentSale?.id || null,
      price: product.userPrice,
    }
    dispatch(saleActions.handleAddOrUpdateItem(payload));
  };

  const handleShowProductDetails = useCallback((product) => {
    setSelectedProductDetails(product);
  }, []);

  const debouncedUpdateQuantity = useCallback(
    debounce((itemId, quantity) => {
      dispatch(saleActions.handleUpdateQuantity({ id: itemId, quantity }));
    }, 500), // Adjust the debounce delay as needed
    []
  );

  const handleUpdateQuantity = (itemId, quantity) => {
    // Update local state immediately
    setItemQuantities(prevQuantities => ({
      ...prevQuantities,
      [itemId]: quantity
    }));
    debouncedUpdateQuantity(itemId, quantity);
  };

  const debouncedUpdatePrice = useCallback(
    debounce((itemId, price) => {
      dispatch(saleActions.handleUpdatePrice({ id: itemId, price }));
    }, 1000), // Adjust the debounce delay as needed
    []
  );

  const handleUpdatePrice = (itemId, price) => {
    // Update local state immediately
    setItemPrices(prevPrices => ({
      ...prevPrices,
      [itemId]: price
    }));
    debouncedUpdatePrice(itemId, price);
  };

  const handleRemoveFromCart = (itemId) => {
    dispatch(saleActions.handleRemoveFromCart({ id: itemId }));
  }

  const handleToggleProductDetails = (product) => {
    if (selectedProductDetails && selectedProductDetails.id === product.id) {
      setSelectedProductDetails(null);
    } else {
      setSelectedProductDetails(product);
    }
  };

  // Debounced search function
  const debouncedSearch = debounce((term) => {
    const searchLower = term.toLowerCase();
    dispatch(productActions.search({
      criteria: {
        query: term,
      },
      page: 1,
      size: 10,
      onSuccess: (items) => {
        setIsSearching(false)
        // Check for exact barcode match

        const matchedItems = items?.filter(p =>
          p.barcode?.toLowerCase().includes(searchLower) ||
          p.code?.toLowerCase().includes(searchLower) ||
          p.description?.toLowerCase().includes(searchLower)
        );


        if (matchedItems.length === 1) {
          // Add to cart directly
          handleAddToCart(matchedItems[0]);
          setSearchTerm('');
        } else if (matchedItems.length > 1 && term.length >= 3) {
          // Show modal with search results
          setSearchResults(items);
          setIsModalOpen(true);
        } else {
          setSearchResults([]);
        }
      }
    }));
  }, 1000);

  // Debounced search function for the modal search input
  const debouncedModalSearch = useCallback(
    debounce((query) => {
      setIsSearching(true);
      dispatch(productActions.search({
        criteria: { query },
        page: 1,
        size: pageSize,
        onSuccess: () => setIsSearching(false)
      }));
    }, 500),
    []
  );

  // Handle modal search input change
  const handleModalSearchChange = (e) => {
    const value = e.target.value;
    setModalSearchTerm(value);
    debouncedModalSearch(value);
  };


  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Automatically trigger search if the input is a barcode (e.g., 13 characters long)
    if (value.length === 13 && /^\d+$/.test(value)) { // Assuming barcodes are numeric and 13 characters long
      debouncedSearch(value);
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      debouncedSearch(searchTerm); // Trigger search when Enter is pressed
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const handleClearCart = () => {
    Swal.fire({
      title: t('cart.clearConfirmMessage'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(saleActions.clearCart());
        setCartPage(1); // Reset cart page

      }
    });
  };


  // Create Sale
  const handleCreateSale = async () => {
    if (cart.length === 0) return;

    const { value: payment } = await Swal.fire({
      title: t('sale.confirmTitle'),
      html: `
      <div class="text-start p-3">
        <div class="mb-3">
          <label class="form-label">${t('sale.amountDue')}</label>
          <input type="text" class="form-control text-end" value="${formatPrice(totalAmount)}" disabled>
        </div>
        <div class="mb-3">
          <label class="form-label">${t('sale.amountPaid')}</label>
          <input type="number" id="paymentInput" class="form-control text-end" min="${totalAmount}" step="0.1">
        </div>
        <div>
          <label class="form-label">${t('sale.changeAmount')}</label>
          <input type="text" id="changeAmount" class="form-control text-end text-success" disabled>
        </div>
      </div>
    `,
      didOpen: () => {
        const paymentInput = Swal.getPopup().querySelector('#paymentInput');
        paymentInput.focus();
        paymentInput.value = totalAmount.toFixed(2);
        paymentInput.addEventListener('input', (e) => {
          const change = Math.max(0, parseFloat(e.target.value) - totalAmount);
          Swal.getPopup().querySelector('#changeAmount').value = formatPrice(change.toFixed(2), false);
        });

        // Add keydown listener to paymentInput
        paymentInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault(); // Prevent line break in input
            // Trigger the confirm button click
            Swal.clickConfirm();
          }
        });
      },
      preConfirm: () => {
        const payment = Swal.getPopup().querySelector('#paymentInput').value;
        if (payment < totalAmount.toFixed(2)) {
          Swal.showValidationMessage(t('sale.insufficientAmount'));
          return false;
        }
        return payment;
      },
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    });

    if (payment) {
      const changeAmount = payment - totalAmount;
      dispatch(saleActions.closeSale({
        id: currentSale?.id,
        onSuccess: async (data) => {
          setCartPage(1);
          await Swal.fire({
            icon: 'success',
            title: t('sale.successTitle'),
            html: `
            <div class="text-start p-3">
              <p class="mb-3">${t('sale.successMessage')}</p>
              <table class="table table-borderless mb-0">
                <tr>
                  <td>${t('sale.amountPaid')}:</td>
                  <td class="text-end"><strong>${formatPrice(payment)}</strong></td>
                </tr>
                <tr>
                  <td>${t('sale.changeAmount')}:</td>
                  <td class="text-end"><strong class="text-success">${formatPrice(changeAmount)}</strong></td>
                </tr>
              </table>
            </div>
          `,
            timer: 3000,
            showConfirmButton: false
          });

          setReceiptData(data);
          toggleModal();
        },
        onError: (error) => {
          Swal.fire({
            icon: 'error',
            title: t('sale.errorTitle'),
            text: error.message || t('sale.errorMessage'),
            confirmButtonColor: '#dc3545'
          });
        }
      }));
    }
  };


  const generatePDF = async () => {
    try {
      let payload = {
        id: receiptData.id,
        onSuccess: (response) => {
          const pdfWindow = window.open();
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(response) +
            "'></iframe>"
          );
        },
      }

      dispatch(saleActions.printReceipt(payload))

    } catch (error) {
      console.error('PDF generation error:', error);
    }
  };



  const DisplayToggle = () => (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="btn-group">
        <Button
          color={displayMode === 'table' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('table')}
          size="sm"
        >
          <FaList className="me-1" /> {t('common.table')}
        </Button>
        <Button
          color={displayMode === 'card' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('card')}
          size="sm"
        >
          <FaTh className="me-1" /> {t('common.cards')}
        </Button>
      </div>

      <div className="d-flex align-items-center gap-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>

        <div className="d-flex align-items-center gap-2">
          <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
            <FaAngleDoubleLeft />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            <FaAngleLeft />
          </Button>

          <span className="mx-2">
            {currentPage} / {totalPages}
          </span>

          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <FaAngleRight />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
            <FaAngleDoubleRight />
          </Button>
        </div>
      </div>
    </div>
  );


  const TableView = () => (
    <>
      <div className="cart-container" style={{
        height: '400px',
        overflowY: 'auto'
      }}>
        <Table bordered hover>
          <thead>
            <tr>
              <th>{t('product.code')}</th>
              <th>{t('product.description')}</th>
              <th>{t('product.salePrice')}</th>
              <th>{t('product.buyingPrice')}</th>
            </tr>
          </thead>
          <tbody>
            {!products || products.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="text-muted">
                    {t('product.noProducts')}
                  </div>
                </td>
              </tr>
            ) : (products.map((product) => (
              <tr key={product.id} onClick={() => handleAddToCart(product)}>
                <td>{product.barcode}</td>
                <td>
                  {product.description.length > 10 ? product.description.substring(0, 10) + '...' : product.description}
                </td>
                <td className="text-end">{formatPrice(product.userPrice, false)}</td>
                <td className="align-middle text-end">{formatPrice(product.buyingPrice, false)}</td>

              </tr>
            ))
            )}
          </tbody>
        </Table>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>
      </div>
    </>
  );

  const CardView = () => (
    <div className="card-container" style={{ height: '600px', overflowY: 'auto' }}>
      <Row xs={1} md={2} lg={3} className="g-4">
        {(!products || products.length === 0) && (
          <Col xs={12} className="text-center py-5">
            <div className="text-muted">
              <FaImage size={48} className="mb-3 text-secondary opacity-50" />
              <h5>{t('product.noProducts')}</h5>
            </div>
          </Col>
        )}
        {products.map(product => (
          <Col key={product.id}>
            <Card
              className="product-card border-0 h-100"
              onClick={() => handleAddToCart(product)}
              style={{
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.08)';
              }}
            >
              <div
                className="card-image-container position-relative"
                style={{ height: '180px', overflow: 'hidden' }}
              >
                {product.imageServerUrl ? (
                  <img
                    src={`${config.baseURL}${product.imageServerUrl}`}
                    alt={product.description}
                    className="w-100 h-100"
                    style={{
                      objectFit: 'cover',
                      objectPosition: 'center',
                      transition: 'transform 0.5s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                    }}
                  />
                ) : (
                  <div
                    className="bg-light d-flex align-items-center justify-content-center w-100 h-100"
                  >
                    <FaImage size={48} className="text-secondary opacity-50" />
                  </div>
                )}
                {product.stock <= 0 && (
                  <div
                    className="position-absolute top-0 end-0 m-2"
                    style={{ zIndex: 1 }}
                  >
                    <Badge
                      color="danger"
                      pill
                      className="px-3 py-2"
                      style={{ fontSize: '0.85rem', fontWeight: 'bold' }}
                    >
                      {t('product.outOfStock')}
                    </Badge>
                  </div>
                )}
              </div>
              <CardBody className="d-flex flex-column p-3">
                <h5
                  className="product-title mb-3 text-truncate fw-bold"
                  title={product.description}
                  style={{ fontSize: '1.1rem' }}
                >
                  {product.description}
                </h5>
                <div className="d-flex justify-content-between align-items-center mt-auto">
                  <div>
                    <p className="product-price mb-0 fw-bold text-primary" style={{ fontSize: '1.25rem' }}>
                      {formatPrice(product.userPrice)}
                    </p>
                    {product.barcode && (
                      <small className="text-muted d-block mt-1" style={{ fontSize: '0.8rem' }}>
                        <FaBarcode className="me-1" size={12} />
                        {product.barcode}
                      </small>
                    )}
                  </div>
                  {product.stock > 0 && (
                    <Button
                      color="primary"
                      size="sm"
                      className="rounded-circle p-0 d-flex align-items-center justify-content-center"
                      style={{ width: '36px', height: '36px' }}
                      title={t('cart.addToCart')}
                    >
                      <FaCartPlus size={16} />
                    </Button>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );


  const toggleChooseProductModal = () => {
    setChooseProductModal(!chooseProductModal);
  };

  const handleCheckboxChange = (productId, checked) => {
    if (checked) {
      setSelectedProductIds((prev) => [...prev, productId]);
    } else {
      setSelectedProductIds((prev) => prev.filter((id) => id !== productId));
    }
  };


  const handleAddSelectedProducts = () => {
    // Find the selected products from searchResults
    const chosen = products.filter((p) => selectedProductIds.includes(p.id));
    // Loop through or map them, call handleAddProduct(p) for each
    const addProductWithDelay = async (product) => {
      await new Promise((resolve) => setTimeout(resolve, 100)); // 100ms delay
      handleAddToCart(product);
    };

    const addProductsSequentially = async () => {
      for (const prod of chosen) {
        await addProductWithDelay(prod);
      }
    };

    addProductsSequentially();
    setIsModalOpen(false);
    setSearchTerm('');
    setSelectedProductIds([]);
  };


  return (
    <Container fluid>
      <Row>
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="position-relative flex-grow-1 me-3">
              <Input
                innerRef={searchInputRef}
                type="text"
                placeholder={t('product.searchFocusHint')}
                value={searchTerm}
                onKeyDown={handleSearchKeyDown}
                onChange={handleSearchChange}
                className={`ps-4 pe-5 ${isSearching ? 'searching' : ''}`}
                title={t('product.searchShortcut')}
              />
              <FaSearch
                style={{
                  position: 'absolute',
                  left: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#adb5bd'
                }}
                size={14}
              />
              <FaBarcode
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#adb5bd'
                }}
                size={20}
                title={t('product.scanHint')}
              />
            </div>
            {/* Add the barcode focus checkbox here */}
            <div className="d-flex align-items-center me-2">
              <Input
                type="checkbox"
                id="barcodeFocusToggle"
                className="me-2"
                checked={barcodeFocus}
                onChange={handleBarcodeFocusToggle}
              />
              <Label for="barcodeFocusToggle" className="mb-0 d-flex align-items-center">
                <FaBarcode className="me-1" />
                {t('product.barcodeFocus', 'Barcode Focus')}
              </Label>
            </div>
            <Button
              color="primary"
              size="sm"
              className="d-flex align-items-center"
              onClick={() => navigate('/sales/history')}
              title={t('sale.viewHistory')}
            >
              <FaHistory className="me-2" />
              {t('sale.viewHistory')}
            </Button>
          </div>
      </Row>
      <Row>
        <Col md={6} className="pe-4">
          <Card className="shadow-sm h-100">
            <CardBody>
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('common.loading')}</span>
                  </div>
                  <div className="mt-2 text-muted">
                    {t('common.loadingData')}
                  </div>
                </div>
              ) : (<>

                <DisplayToggle />
                {displayMode === 'table' ? <TableView /> : <CardView />}
              </>)}
            </CardBody>
          </Card>
        </Col>

        <Col md={6} className="ps-4 border-start">

          {selectedProductDetails && (
            <div className="mb-3 p-3 bg-light border rounded" style={{ fontSize: '12px' }}>
              <div className="d-flex justify-content-between align-items-center">
                <h6>{t('product.productDetails')}</h6>
                <Button color="link" className="p-0 text-danger" onClick={handleCloseProductDetails}>
                  <FaTimes size={16} />
                </Button>
              </div>
              <Row>

                <Col md={4}>
                  <p>
                    <strong>{t('product.description')}:</strong> {selectedProductDetails.productDescription}
                  </p>
                </Col>
                <Col md={3}>
                  <p>
                    <strong>{t('product.buyingPrice')}:</strong> {formatPrice(selectedProductDetails.productBuyingPrice ?? 0)}
                  </p>
                </Col>
                <Col md={3}>
                  <p>
                    <strong>{t('product.salePrice')}:</strong> {formatPrice(selectedProductDetails.productUserPrice ?? 0)}
                  </p>
                </Col>
                <Col md={2}>
                  <p>
                    <strong>{t('product.stockQty')}:</strong> {selectedProductDetails.productStock ?? 0}
                  </p>
                </Col>
              </Row>
            </div>
          )}
          <Card >
            <div className="card-header bg-light d-flex justify-content-between align-items-center py-3">
              <div className="d-flex align-items-center">
                <div className="position-relative me-2">
                  <FaShoppingCart size={18} className="text-primary" />
                  {cart.length > 0 && (
                    <Badge
                      color="danger"
                      pill
                      className="position-absolute d-flex align-items-center justify-content-center"
                      style={{
                        top: '-6px',
                        right: '-10px',
                        fontSize: '0.65rem',
                        width: '16px',
                        height: '16px',
                        padding: 0
                      }}
                    >
                      {cart.reduce((total, item) => total + item.quantity, 0)}
                    </Badge>
                  )}
                </div>
                <h6 className="mb-0 fw-bold">{t('cart.title')}</h6>
              </div>

              {/* {cart.length > 0 && (
                <Button
                  color="danger"
                  size="sm"

                  onClick={handleClearCart}
                >
                  <FaTrash size={12} />
                </Button>
              )} */}
            </div>
            <CardBody className="p-0">

              {cart.length === 0 ? (
                <div className="text-center py-5">
                  <img
                    src={emptyCart}
                    alt="Empty Cart"
                    style={{
                      width: '150px',
                      opacity: '0.5',
                      marginBottom: '1rem'
                    }}
                  />
                  <p className="text-muted">{t('cart.empty')}</p>
                </div>
              ) : (
                <>
                  <Card className="mb-3">
                    <CardBody className="p-0">
                      <div style={{
                        height: '400px',
                        overflowY: 'auto'
                      }}>
                        <Table hover responsive className="mb-0 cart-table" >
                          <thead className="bg-light position-sticky top-0" style={{ zIndex: 1 }}>
                            <tr>
                              <th >{t('product.code')}</th>
                              <th >{t('product.description')}</th>
                              <th>{t('cart.unitPrice')}</th>
                              <th>{t('cart.quantity')}</th>
                              <th>{t('cart.subtotal')}</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {cart.map((item) => (
                              <tr key={item.id} className={`align-middle ${highlightedItem === item.id ? 'table-info' : ''}`}
                                onClick={() => handleShowProductDetails(item)}

                              >
                                <td style={{ fontSize: '0.9rem' }}>
                                  {item.productBarcode}
                                </td>
                                <td style={{ maxWidth: '200px', fontSize: '0.9rem' }}>
                                  {item.productDescription.length > 20 ? item.productDescription.substring(0, 20) + '...' : item.productDescription}

                                </td>
                                <td >
                                  <Input
                                    type="text" // Change to "text" to handle custom input
                                    innerRef={highlightedItem === item.id ? priceInputRef : null}
                                    value={itemPrices ? itemPrices[item.id] !== undefined ? itemPrices[item.id] : item.price : item.price}
                                    onFocus={(e) => e.target.select()} // Select the field content on focus
                                    onChange={(e) => {
                                      const value = e.target.value.replace(',', '.'); // Replace commas with dots
                                      if (!isNaN(value) || value === '') { // Allow only valid numbers or empty input
                                        handleUpdatePrice(item.id, value || 0); // Update the price
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        e.preventDefault();
                                        searchInputRef.current?.focus();
                                      }
                                    }}
                                    className="form-control form-control-sm text-center"
                                    style={{ width: '90px' }}
                                  />
                                </td>
                                <td >
                                  <Input
                                    type="number"
                                    min="1"
                                    innerRef={highlightedItem === item.id ? quantityInputRef : null}
                                    value={itemQuantities ? itemQuantities[item.id] !== undefined ? itemQuantities[item.id] : item.quantity : item.quantity}
                                    onFocus={(e) => e.target.select()} // Select the field content on focus
                                    onChange={(e) => handleUpdateQuantity(item.id, parseInt(e.target.value) || 1)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        e.preventDefault();
                                        searchInputRef.current?.focus();
                                      }
                                    }}
                                    className="form-control form-control-sm text-center"
                                    style={{ width: '90px' }}
                                  />
                                </td>
                                <td>
                                  {formatPrice(item.price * item.quantity, false)}
                                </td>
                                <td style={{ width: '40px' }}>
                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleRemoveFromCart(item.id)}
                                  >
                                    <FaTrash size={12} />
                                  </Button>
                                </td>
                                <td style={{ width: '40px' }}>
                                  <Button
                                    color="info"
                                    size="sm"
                                    onClick={() => handleToggleProductDetails(item)}
                                  >
                                    <FaEye size={12} />
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>

                    </CardBody>

                  </Card>
                  <div className="border-top p-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="fs-5 fw-bold text-muted ps-2">
                        {t('cart.total')}
                      </div>
                      <div className="fs-4 fw-bold text-primary pe-2">
                        {formatPrice(totalAmount)}
                      </div>
                    </div>

                    <Button
                      color="success"
                      className="w-100 mt-1 py-2"
                      size="lg"
                      onClick={handleCreateSale}
                    >
                      <FaShoppingCart className="me-2" />
                      {t('cart.checkout')}
                    </Button>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Col>

      </Row>
      {/* Receipt Modal */}
      <Modal isOpen={modal} toggle={() => setModal(false)}>
        <ModalHeader toggle={() => setModal(false)}>
          {t('receipt.title')}
        </ModalHeader>
        <ModalBody>
          <div
            id="receipt-content"
            className="p-4 bg-white shadow-sm rounded"
            style={{ width: '100%' }}
          >
            {/* Header */}
            <div className="text-center mb-4">
              <h5 className="mb-2">
                <FaStore className="me-2 text-secondary" />
                {businessName}
              </h5>
              <small className="d-block mb-2">
                <FaMapMarkerAlt className="me-1 text-secondary" />
                {address}
              </small>
              <div className="d-flex justify-content-center align-items-center gap-3">
                {telephone && (
                  <small>
                    <FaWhatsapp className="me-1 text-secondary" />
                    {telephone}
                  </small>
                )}
                <small>
                  <FaEnvelope className="me-1 text-secondary" />
                  {email}
                </small>
              </div>
            </div>

            <hr />

            {/* Receipt Details */}
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <FaReceipt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.receiptNo')} </span>
                  {receiptData?.numero}
                </div>
                <div>
                  <FaCalendarAlt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.date')} </span>
                  {receiptData?.createdAt}
                </div>
              </div>
              <div>
                <FaUser className="me-2 text-secondary" />
                <span className="fw-bold">{t('sale.receipt.cashier')} </span>
                {fullName}
              </div>
            </div>

            <hr />

            {/* Products Table */}
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>{t('product.description')}</th>
                  <th className="text-end">{t('sale.receipt.price')}</th>
                  <th className="text-end">{t('sale.receipt.quantity')}</th>
                  <th className="text-end">{t('sale.receipt.total')}</th>
                </tr>
              </thead>
              <tbody>
                {receiptData && receiptData.items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.productDescription}</td>
                    <td className="text-end">{formatPrice(item.price, false)}</td>
                    <td className="text-end">{item.quantity}</td>
                    <td className="text-end">{formatPrice(item.price * item.quantity, false)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <hr />

            {/* Totals */}
            <div className="text-end mb-4">
              {/* <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.subtotal')}</span>
                {formatPrice(receiptData.totalAmount)}
              </div> */}
              {/* <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.tax')}</span>
                {formatPrice(0)}
              </div> */}
              <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.total')}</span>
                {formatPrice(receiptData?.totalAmount)}
              </div>

            </div>

            {/* Footer */}
            <div className="text-center mt-4">
              <p className="mb-1">{t('sale.receipt.thankYou')}</p>
              <small className="text-muted">{t('sale.receipt.footer')}</small>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={generatePDF} onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              generatePDF();
            }
          }}>
            <FaPrint className="me-1" />
            {t('receipt.printBill')}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Payment Modal */}
      <Modal isOpen={paymentModal} toggle={togglePaymentModal}>
        <ModalHeader toggle={togglePaymentModal}>
          {t('payment.title')}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>{t('payment.totalDue')}</Label>
            <Input
              type="number"
              value={totalAmount.toFixed(2)}
              disabled
              className="bg-light"
            />
          </FormGroup>

          <FormGroup>
            <Label>{t('payment.method')}</Label>
            <Input
              type="select"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <option value="cash">{t('payment.cash')}</option>
              <option value="card">{t('payment.card')}</option>
            </Input>
          </FormGroup>


        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handlePayment}>
            {t('payment.confirm')}
          </Button>
          <Button color="secondary" onClick={togglePaymentModal}>
            {t('payment.cancel')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={clearCartModal} toggle={toggleClearCartModal}>
        <ModalHeader toggle={toggleClearCartModal}>
          {t('cart.clearConfirmTitle')}
        </ModalHeader>
        <ModalBody>
          {t('cart.clearConfirmMessage')}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleClearCart}>
            {t('cart.confirm')}
          </Button>
          <Button color="secondary" onClick={toggleClearCartModal}>
            {t('cart.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={chooseProductModal} toggle={toggleChooseProductModal} size="xl">
        <ModalHeader toggle={toggleChooseProductModal}>
          {t('product.chooseProduct')}
        </ModalHeader>
        <ModalBody>
          <Input
            type="text"
            placeholder={t('product.searchPlaceholder')}
            value={modalSearchTerm}
            onChange={handleModalSearchChange}
            className="mb-3"
          />
          <DisplayToggle />
          {displayMode === 'table' ? <TableView /> : <CardView />}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleChooseProductModal}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} size='lg'>
          <ModalHeader toggle={() => setIsModalOpen(false)}>
            {t('common.searchResults')}
          </ModalHeader>
          <ModalBody style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <Table bordered hover size="sm" style={{ fontSize: '14px', fontWeight: 'bold' }}>
              <thead>
                <tr>
                  <th></th>
                  <th>{t('inventory.codeArticle')}</th>
                  <th style={{ width: '50%' }}>{t('product.description')}</th>
                  <th>{t('product.buyingPrice')}</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.map((product) => (
                  <tr key={product.id} style={{ whiteSpace: 'nowrap', height: '20px' }}>
                    <td>
                      <Input
                        type="checkbox"
                        checked={selectedProductIds.includes(product.id)}
                        onChange={(e) => handleCheckboxChange(product.id, e.target.checked)}
                      />
                    </td>
                    <td>{product.barcode}</td>
                    <td>{product.description}</td>
                    <td>{formatPrice(product.buyingPrice)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleAddSelectedProducts} disabled={selectedProductIds.length === 0}>
              {t('common.addSelected')}
            </Button>
          </ModalFooter>
        </Modal>
      )}

    </Container>
  );
};

export default SaleForm;
